export const state = () => ({
  requisites: []
})

export const getters = {
  getList: (state) => {
    return state.requisites
  },
  getCount: (state) => {
    return state.requisites.length
  }
}

export const mutations = {
  getList (state, requisites) {
    state.requisites.splice(0, state.requisites.length, ...requisites)
  }
}

export const actions = {
  getList ({ commit }) {
    return this.$axios.get(process.env.API_ENDPOINT + 'user/notifications').then((response) => {
      commit('getList', response.data)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
